import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaPageView } from "../asset/js/metaPixel";

export default function MetaPixelTracker() {
  const location = useLocation();

  useEffect(() => {
    trackMetaPageView();
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleConsent = () => trackMetaPageView();
    window.addEventListener("bidit-marketing-consent", handleConsent);
    return () => window.removeEventListener("bidit-marketing-consent", handleConsent);
  }, []);

  return null;
}
